import {
  LayoutDashboard,
  Users,
  Gem,
  Settings,
  Coins,
  Receipt,
  Wrench,
  ArrowLeftRight,
  PiggyBank,
  ClipboardList,
  FileDown,
  CalendarDays,
  FileBarChart2,
  PackageSearch,
  Hourglass,
  TrendingUp,
  History,
} from 'lucide-react';

/**
 * Sidebar / drawer navigation, grouped so the eighteen destinations read as a
 * floor plan rather than a single scrolling list. Routes not yet built
 * (Phase 4+) are listed with `disabled: true` so the shape of the finished
 * app is visible from Phase 2 on, rather than the nav silently growing
 * module by module.
 */
export const NAV_GROUPS = [
  {
    label: null,
    items: [{ to: '/', label: 'Dashboard', icon: LayoutDashboard }],
  },
  {
    label: 'Counter',
    items: [
      { to: '/customers', label: 'Customers', icon: Users },
      { to: '/items', label: 'Items', icon: Gem },
      { to: '/invoices', label: 'Sales & GST invoices', icon: Receipt },
      { to: '/gold-purchases', label: 'Gold purchase', icon: Coins },
      { to: '/repairs', label: 'Repair vouchers', icon: Wrench },
      { to: '/issue-receipt', label: 'Issue & receipt', icon: ArrowLeftRight },
      { to: '/chit', label: 'Chit schemes', icon: PiggyBank },
    ],
  },
  {
    label: 'Reports',
    items: [
      { to: '/reports/daily-sales', label: 'Daily sales', icon: CalendarDays },
      { to: '/reports/gst-sales-register', label: 'GST sales register', icon: FileBarChart2 },
      { to: '/reports/stock-register', label: 'Stock register', icon: ClipboardList },
      { to: '/reports/pending-issues', label: 'Pending issues', icon: PackageSearch },
      { to: '/reports/repair-status', label: 'Repair status', icon: Hourglass },
      { to: '/reports/chit-dues', label: 'Chit dues', icon: PiggyBank },
      { to: '/reports/outstanding-balances', label: 'Outstanding balances', icon: TrendingUp },
      { to: '/reports/audit-log', label: 'Audit log', icon: History },
      { to: '/reports/exports', label: 'Export data', icon: FileDown },
    ],
  },
  {
    label: null,
    items: [{ to: '/settings', label: 'Settings', icon: Settings }],
  },
];

// Flat list — kept for anything that just needs every route (none currently
// does, but grouping NAV_GROUPS by hand each time it changes invites drift).
export const NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items);
